// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.my-input[data-v-a2498992] {\r\n  margin: 10px;\r\n  width: 140px;\r\n  height: 32px;\n}\r\n", ""]);
// Exports
module.exports = exports;
